
import React, { Suspense } from 'react';

import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import Loading from './components/loader/loading';

import Footer from "./components/footer/footer";
import MyApps from "./components/myApps/myApps";

import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './helpers/appInsights';
import PageHeader from './components/header/pageHeader';
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

function App() {
  const { accounts, inProgress } = useMsal();

  if (inProgress !== InteractionStatus.None || accounts.length === 0) {
    return null;
  }

  const userName = accounts[0].username ?? accounts[0].idTokenClaims.emails[0];

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <I18nextProvider i18n={i18n}>
          <PageHeader/>
          <MyApps userName = {userName} />
        </I18nextProvider>
      </Suspense>
      <Footer copy={"© " + (new Date().getFullYear() + " halley.app")} />
    </React.Fragment>
  );
}

export default withAITracking(reactPlugin, App);
